// ui
import { Box, Alert } from "@mui/material";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

// ★cmd-po_1139: PoModalShell + PoButton で catalog 外殻を導入
// modalTestId="modal-startstop"(既存), frameTestId="modal-startstop-frame"(既存) を維持
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

interface ProductServiceStartStopModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  startStopDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setStartStopDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  startStopData: () => void;
}

export function ProductServiceStartStopModal(
  props: ProductServiceStartStopModalProps
) {
  const {
    onModal,
    swCloseModal,
    startStopDataInf,
    setStartStopDataInf,
    startStopData,
  } = props;

  // success/failed Button は testid 無し（既存維持）
  // mapping は [data-testid="modal-startstop-footer"] button で構造選択（A-4）
  const footer =
    startStopDataInf.status === "open" ? (
      <>
        <PoButton
          variant="secondary"
          data-testid="modal-startstop-cancel-button"
          onClick={swCloseModal}
        >
          閉じる
        </PoButton>
        {/* ★保全ガード③: start⇔stop文言/アイコン切替は不可触 */}
        <PoButton
          variant="primary"
          data-testid="modal-startstop-confirm-button"
          onClick={startStopData}
        >
          {startStopDataInf.key.startStop === "start" ? "再開" : "停止"}
          {startStopDataInf.key.startStop === "start" ? (
            <PlayCircleOutlineIcon fontSize="small" />
          ) : (
            <DoDisturbAltIcon fontSize="small" />
          )}
        </PoButton>
      </>
    ) : startStopDataInf.status === "success" ? (
      <PoButton variant="secondary" onClick={swCloseModal}>
        閉じる
      </PoButton>
    ) : startStopDataInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        onClick={() =>
          setStartStopDataInf({
            ...startStopDataInf,
            status: "open",
            message: "",
          })
        }
      >
        戻る
      </PoButton>
    ) : null;

  return (
    <PoModalShell
      open={onModal}
      title="取扱い停止・再開"
      onClose={swCloseModal}
      testidPrefix="modal-startstop"
      modalTestId="modal-startstop"
      frameTestId="modal-startstop-frame"
      footer={footer}
    >
      {startStopDataInf.status === "open" ? (
        <>
          {/* ★保全ガード③: start⇔stop文言/アイコン/警告色切替は不可触 */}
          <Alert
            severity="error"
            sx={{
              bgcolor: "var(--sem-error-bg, #f6d5d1)",
              color: "var(--sem-error, #a53229)",
              fontSize: 12,
              borderRadius: "var(--radius-md, 10px)",
              p: "var(--sp-3, 12px) var(--sp-4, 16px)",
              "& .MuiAlert-icon": { color: "var(--sem-error, #a53229)" },
            }}
          >
            {startStopDataInf.key.startStop === "start" ? (
              <>
                取扱いが再開されます。
                <br />
                ※再開後、パートナーがエントリー可能となります。
              </>
            ) : startStopDataInf.key.startStop === "stop" ? (
              <>
                取扱いが停止されます。
                <br />
                ※停止後、パートナーがエントリー不可能となります。
                <br />
                ※すでに登録済のエントリーに影響はありません。
              </>
            ) : null}
          </Alert>
        </>
      ) : startStopDataInf.status === "success" ? (
        <Box className="result-state -success" data-testid="result-state-success">
          <span className="rs-title">成功しました。</span>
        </Box>
      ) : startStopDataInf.status === "failed" ? (
        <Box className="result-state -failed" data-testid="result-state-failed">
          <span className="rs-title">{startStopDataInf.message}</span>
        </Box>
      ) : null}
    </PoModalShell>
  );
}
